export default __webpack_public_path__ + "static/media/8_1.78fab57e.png";